import type { SVGProps } from 'react';
const SvgKebabIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={13} fill="none" {...props}>
    <path fill="#000" d="M0 0h17v1H0zM0 6h17v1H0zM0 12h17v1H0z" />
  </svg>
);
export default SvgKebabIcon;
